import React from 'react';
import styles from './Button.module.css';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import RefreshSharpIcon from '@mui/icons-material/RefreshSharp';

import MaterialButton from '@mui/material/Button';

import {
    KeyboardBackspace,
    Delete,
    Search,
    KeyboardArrowDown,
    ArrowDropDown,
    MoreVert,
    PrintRounded,
    HelpRounded,
    ArrowRightAltRounded,
    EditSharp,
    FormatListBulleted,
    AppsSharp,
    VerticalAlignTopSharp,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    ArrowLeft,
    Phone,
    Twitter,
    Facebook,
    Instagram,
    LinkedIn,
    Warning,
    OpenInNew,
    AttachFile,
    DeleteForever,
    ExitToApp,
    ClearAll,
    CheckBoxOutlineBlank,
    CheckBox,
    Add,
    CheckCircle,
    Cancel,
    FileDownload
} from '@mui/icons-material';

import closeIcon from './../../../resources/icons/svg/close.svg';
import certificateIcon from './../../../resources/icons/svg/certficate.svg';
import exportIcon from './../../../resources/icons/image/export.png';
import downloadIcon from './../../../resources/icons/image/download.png';
import downloadXlsIcon from './../../../resources/icons/image/xls.png';
import downloadPdfIcon from './../../../resources/icons/image/pdf.png';
export default function Button(props) {
    if (props.role === "_blank") return null;

    const {
        type,
        role,
        theme,
        clickHandler,
        customClass,
        startIcon,
        endIcon,
        style,
        iconStyle,
        disabled,
        tooltipTitle,
        isCornerRounded = false,
        // children,
        // ...restProps 
    } = props;

    const icon = startIcon ? startIcon : endIcon;
    let iconType = null;
    let cssClasses = [];

    // Role-based styling
    switch (role) {
        case "link":
            cssClasses.push(styles.Link);
            break;
        case "icon":
            cssClasses.push(styles.IconButton);
            break;
        case "pagination_link":
            cssClasses.push(styles.PaginationLink);
            break;
        case "sort_filter":
            cssClasses.push(styles.SortFilter);
            break;
        default:
            cssClasses.push(styles.Button);
    }

    // Icon rendering logic (same as before)
    const defaultIconProps = {
        style: iconStyle || null,
        className: styles.Icon
    };

    switch (icon) {
        case "search":
            iconType = <Search {...defaultIconProps} />;
            break;
        case "delete":
            iconType = <Delete {...defaultIconProps} />;
            break;
        case "warning":
            iconType = <Warning {...defaultIconProps} />;
            break;
        case "print":
            iconType = <PrintRounded {...defaultIconProps} />;
            break;
        case "right":
            iconType = <ArrowRightAltRounded {...defaultIconProps} />;
            break;
        case "edit":
            iconType = <EditSharp {...defaultIconProps} />;
            break;
        case "help":
            iconType = <HelpRounded {...defaultIconProps} />;
            break;
        case "down":
            iconType = <ArrowDropDown {...defaultIconProps} />;
            break;
        case "chevron_down":
            iconType = <KeyboardArrowDown {...defaultIconProps} />;
            break;
        case "chevron_left":
            iconType = <KeyboardArrowLeft {...defaultIconProps} />;
            break;
        case "chevron_right":
            iconType = <KeyboardArrowRight {...defaultIconProps} />;
            break;
        case "list":
            iconType = <FormatListBulleted {...defaultIconProps} />;
            break;
        case "grid":
            iconType = <AppsSharp {...defaultIconProps} />;
            break;
        case "arrow_left":
            iconType = <ArrowLeft {...defaultIconProps} />;
            break;
        case "more":
            iconType = <MoreVert {...defaultIconProps} />;
            break;
        case "arrow_left_long":
            iconType = <KeyboardBackspace {...defaultIconProps} />;
            break;
        case "vertical_top":
            iconType = <VerticalAlignTopSharp {...defaultIconProps} />;
            break;
        case "attachment":
            iconType = <AttachFile {...defaultIconProps} />;
            break;
            case "dashboard":
            iconType = <DashboardIcon {...defaultIconProps}  />;
            break;
        case "phone":
            iconType = <Phone {...defaultIconProps} />;
            break;
        case "clear":
            iconType = <ClearAll {...defaultIconProps} />;
            break;
        case "checkbox_unchecked":
            iconType = <CheckBoxOutlineBlank {...defaultIconProps} />;
            break;
        case "checkbox_checked":
            iconType = <CheckBox {...defaultIconProps} />;
            break;
        case "certificate":
            iconType = <img src={certificateIcon} {...defaultIconProps} />;
            break;
        case "close":
            iconType = <img src={closeIcon} {...defaultIconProps} />;
            break;
        case "export":
            iconType = <FileUploadIcon {...defaultIconProps} />;
            break;
        case "download":
            iconType = <img src={downloadIcon} {...defaultIconProps} />;
            break;
        case "download_xls":
        case "download_xlsx":
            iconType = <img src={downloadXlsIcon} {...defaultIconProps} />;
            break;
        case "download_pdf":
            iconType = <img src={downloadPdfIcon} {...defaultIconProps} />;
            break;
        case "twitter":
            iconType = <Twitter {...defaultIconProps} />;
            break;
        case "facebook":
            iconType = <Facebook {...defaultIconProps} />;
            break;
        case "instagram":
            iconType = <Instagram {...defaultIconProps} />;
            break;
        case "linkedIn":
            iconType = <LinkedIn {...defaultIconProps} />;
            break;
        case "new_window":
            iconType = <OpenInNew {...defaultIconProps} />;
            break;
        case "remove_all":
            iconType = <DeleteForever {...defaultIconProps} />;
            break;
        case "exit":
            iconType = <ExitToApp {...defaultIconProps} />;
            break;
        case "add":
            iconType = <Add {...defaultIconProps} />;
            break;
        case "accept":
            iconType = <CheckCircle {...defaultIconProps} />;
            break;
        case "cancel":
            iconType = <Cancel {...defaultIconProps} />;
            break;
        case "refresh":
            iconType = <RefreshSharpIcon />;
            break;
        case "downloadCloudIcon":
            iconType = (
                <svg xmlns="http://www.w3.org/2000/svg" className={styles.downloadCloudBtn} viewBox="0 0 512 512">
                    <path d="M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56M192 400.1l64 63.9 64-63.9M256 224v224.03" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                </svg>
            );
            break;
        case "uploadCloudIcon":
            iconType = (
                <svg xmlns="http://www.w3.org/2000/svg" className={styles.uploadCloudIcon} viewBox="0 0 512 512">
                    <path d="M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                    <path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M320 255.79l-64-64-64 64M256 448.21V207.79" />
                </svg>
            );
            break;
        case "fileDownloadIcon":
            iconType = <FileDownload />
            break;
        default:
            break;
    }

    // Theme-related custom classNames
    if (customClass) cssClasses.push(customClass);
    if (isCornerRounded) cssClasses.push(styles.ButtonWithRoundedCorner);
    if (theme === "white") cssClasses.push(styles.White);
    if (theme === "silver") cssClasses.push(styles.Silver);
    if (theme === "black") cssClasses.push(styles.Black);
    if (theme === "drs-checkout") cssClasses.push(styles.DRSCheckout);
    if (theme === "drs-checkout-filled") cssClasses.push(styles.DRSCheckoutFilled);
    if (theme === "small") cssClasses.push(styles.MinimumWidth);
    if( theme === "drs-icon") cssClasses.push(styles.DRSIcon);

    const elementProps = {...props};
    delete elementProps.theme;

    return (
        <div className={styles.ButtonWrapper}>
            <MaterialButton
                {...elementProps} 
                className={cssClasses.join(" ")}
                style={style || null}
                onClick={clickHandler || null}
                startIcon={startIcon && iconType ? iconType : null}
                endIcon={endIcon && iconType ? iconType : null}
                disabled={disabled || false}
                disableRipple={true}
                title={tooltipTitle || null}
            >
                {props.children ? props.children : ""}
            </MaterialButton>
        </div>
    );
}
